import { FeatureBlock, FeatureComparison } from "../_copy-template"
import Loyalty from "~images/pages/comparison/features/loyalty.png"

export function getLoyaltyCopy(competitor: FeatureBlock): FeatureComparison {
    return {
        name: "Loyalty Program",
        image: Loyalty,
        chckup: {
            showCheck: true,
            description:
                "With Chckvet, you can offer a transaction-based loyalty program customized to your practice. Points are awarded based on how much a client has spent with you. Reward your clients for their loyalty & let them easily redeem their rewards from their pet portal.",
        },
        competitor,
        href: "/features/loyalty",
    }
}
